// ================================
// 🔒 LOCK SCROLL WHEN MINI CART IS OPEN
// ================================

document.addEventListener('DOMContentLoaded', function () {

  // 👉 On cible TON mini cart (vu dans ton inspecteur)
  const miniCart = document.querySelector('#mini-cart');
  if (!miniCart) return;

  // 👉 On stock la position scroll actuelle
  let scrollY = 0;

  // ================================
  // 🔒 BLOQUER LE SCROLL
  // ================================
  function lockScroll() {

    // 👉 Evite de lock 2 fois
    if (document.body.classList.contains('frizi-scroll-locked')) return;

    // 👉 On sauvegarde la position actuelle
    scrollY = window.scrollY || window.pageYOffset;

    // 👉 On bloque le body (technique solide mobile + chrome)
    document.body.classList.add('frizi-scroll-locked');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  // ================================
  // 🔓 DEBLOQUER LE SCROLL
  // ================================
  function unlockScroll() {

    if (!document.body.classList.contains('frizi-scroll-locked')) return;

    document.body.classList.remove('frizi-scroll-locked');

    // 👉 Reset styles
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    // 👉 On remet le scroll où il était
    window.scrollTo(0, scrollY);
  }

  // ================================
  // 👀 DETECTER SI MINI CART OUVERT
  // ================================
  function isMiniCartOpen() {
    return (
      miniCart.classList.contains('open-above-overlay') || // ton cas principal
      miniCart.classList.contains('open') ||
      miniCart.classList.contains('active') ||
      miniCart.getAttribute('aria-hidden') === 'false'
    );
  }

  // ================================
  // 🔄 CHECK ET APPLY
  // ================================
  function checkMiniCart() {
    if (isMiniCartOpen()) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  // ================================
  // 👂 OBSERVER LES CHANGEMENTS
  // ================================
  const observer = new MutationObserver(checkMiniCart);

  observer.observe(miniCart, {
    attributes: true,
    attributeFilter: ['class', 'aria-hidden']
  });

  // 👉 fallback (clics UI)
  document.addEventListener('click', function () {
    setTimeout(checkMiniCart, 50);
  });

  // 👉 init
  checkMiniCart();
});


// ================================
// MINI CART - Sync résumé après update quantité
// Recalcule Sous-total / Livraison / Total estimé depuis /cart.js
// Scope : #mini-cart uniquement
// ================================

(function () {
  // Evite de wrapper plusieurs fois le cartService
  if (window.friziMiniCartSummarySyncReady) return;
  window.friziMiniCartSummarySyncReady = true;

  // Format EUR propre
  function friziFormatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  let friziCartSummarySyncVersion = 0;

  function friziApplyFreshCartSummary(doc) {
    const freshSummary = doc.querySelector('.cart-summary__meta');
    if (!freshSummary) return false;

    document.querySelectorAll('.cart-summary__meta').forEach((summary) => {
      summary.innerHTML = freshSummary.innerHTML;
      summary.querySelectorAll('.icon').forEach((icon) => {
        icon.classList.add('loaded');
      });
    });

    return true;
  }

  function friziResetCartQuantityState() {
    const service = window.cartService;
    if (!service) return;

    if (service._errorTimeoutByKey) {
      service._errorTimeoutByKey.forEach((timeoutId) => {
        clearTimeout(timeoutId);
      });
    }

    [
      '_desiredQtyByKey',
      '_inFlightByKey',
      '_inventoryBlockedByKey',
      '_maxQtyByKey',
      '_errorTimeoutByKey',
      '_versionByKey'
    ].forEach((key) => {
      if (service[key]?.clear) {
        service[key].clear();
      }
    });

    document.querySelectorAll('.cart-item__error').forEach((errorEl) => {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    });
  }

  function friziApplyFreshCartItems(doc) {
    if (!window.cartService?.renderItems) return false;

    friziResetCartQuantityState();
    window.cartService.renderItems(doc);
    friziResetCartQuantityState();

    document.querySelectorAll('.cart-item').forEach((item) => {
      window.cartService.manageState?.(item);
    });

    return true;
  }

  async function friziSyncCartSummariesFromSection(syncItems = true) {
    const syncVersion = ++friziCartSummarySyncVersion;
    const response = await fetch('/cart?section_id=main-cart&_ts=' + Date.now(), {
      cache: 'no-store'
    });
    const html = await response.text();

    if (syncVersion !== friziCartSummarySyncVersion) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (syncItems) {
      friziApplyFreshCartItems(doc);
    }
    const summaryUpdated = friziApplyFreshCartSummary(doc);
    if (!summaryUpdated && doc.querySelector('.cart__empty')) {
      await friziSyncMiniCartSummary();
    }
  }

  function friziScheduleCartSummarySync(delay) {
    setTimeout(function () {
      friziSyncCartSummariesFromSection(false).catch(friziSyncMiniCartSummary);
    }, delay);
  }

  // Met à jour uniquement le résumé du mini-cart
  async function friziSyncMiniCartSummary() {
    const miniCart = document.querySelector('#mini-cart');
    if (!miniCart) return;

    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    const cart = await response.json();

    const subtotal = cart.total_price || 0;

    const orderTotalLine = miniCart.querySelector('.frizi-order-total-line');
    const subtotalLine = miniCart.querySelector('.cart-summary__line-items[data-has-free-delivery-tag]');
    const freeShippingThreshold = Number(orderTotalLine?.dataset.freeShippingThreshold || 4000);
    const hasFreeDeliveryTag =
      subtotalLine?.dataset.hasFreeDeliveryTag === 'true' ||
      orderTotalLine?.dataset.hasFreeDeliveryTag === 'true';

    const isFreeShipping = hasFreeDeliveryTag || (freeShippingThreshold > 0 && subtotal >= freeShippingThreshold);
    const estimatedTotal = cart.item_count === 0 ? 0 : subtotal;
    const amountLeft = Math.max(freeShippingThreshold - subtotal, 0);

    // Nombre d'articles
    const countEl = miniCart.querySelector('.cart-summary__header p:last-child');
    if (countEl) {
      countEl.textContent = cart.item_count + ' ' + (cart.item_count > 1 ? 'articles' : 'article');
    }

    // Sous-total
    const subtotalEl = miniCart.querySelector('.cart-total-price');
    if (subtotalEl) {
      subtotalEl.textContent = friziFormatMoney(subtotal);
    }

    // Livraison
    const shippingEl = miniCart.querySelector('.frizi-shipping-value');
    if (shippingEl) {
      shippingEl.textContent = isFreeShipping ? 'Gratuite' : 'Calculée au paiement';
    }

    // Total estimé
    const totalEl = miniCart.querySelector('.frizi-estimated-total');
    if (totalEl) {
      totalEl.textContent = friziFormatMoney(estimatedTotal);
    }

    // Barre livraison gratuite : masquée si panier vide
    const freeShippingBox = miniCart.querySelector('.cart-summary__free-shipping');
    if (freeShippingBox) {
    if (cart.item_count === 0) {
        freeShippingBox.style.display = 'none';
    } else {
        freeShippingBox.style.display = '';

        if (hasFreeDeliveryTag) {
        freeShippingBox.innerHTML = '<p class="free-shipping-qualified">✓ Votre commande bénéficie de la livraison offerte.</p>';
        } else if (isFreeShipping) {
        freeShippingBox.innerHTML = '<p class="free-shipping-qualified">✓ Vous avez bénéficié de la gratuité des frais de port</p>';
        } else {
        freeShippingBox.innerHTML =
            '<p class="free-shipping-left" data-percentage="0">Vous avez <span id="amount-left">' +
            friziFormatMoney(amountLeft) +
            '</span> restant jusqu’à la livraison gratuite.</p>';
        }
    }
    }
  }

  // Wrapper propre du cartService : après chaque update quantité, on resynchronise
  function friziPatchCartService() {
    if (!window.cartService || window.cartService.friziMiniCartSummaryPatched) return false;

    const originalChangeCartItem = window.cartService.changeCartItem.bind(window.cartService);

    window.cartService.changeCartItem = async function () {
      const result = await originalChangeCartItem(...arguments);

      // Le rendu Ajax remplace le contenu mais pas toujours les data-* du résumé.
      friziScheduleCartSummarySync(150);
      friziScheduleCartSummarySync(600);

      return result;
    };

    window.cartService.friziMiniCartSummaryPatched = true;
    return true;
  }

  // Le cartService peut arriver après frizi-custom.js, donc on attend proprement
  const interval = setInterval(function () {
    if (friziPatchCartService()) {
      clearInterval(interval);
      friziSyncCartSummariesFromSection().then(friziSyncMiniCartSummary).catch(friziSyncMiniCartSummary);
    }
  }, 100);

  // Sécurité : stop après 5 secondes
  setTimeout(function () {
    clearInterval(interval);
  }, 5000);
})();
